import { CheckoutStatus } from "@/types";
import {
  IDV_VERIFICATION_CONFIG,
  QUESTIONNAIRE_VERIFICATION_CONFIG,
} from "@/modules/external-verification/config";

/** Statuses that keep the user on plan selection with a loading screen while polling. */
export const EXTERNAL_VERIFICATION_LOADING_STATUSES: CheckoutStatus[] = [
  ...QUESTIONNAIRE_VERIFICATION_CONFIG.loadingStatuses,
  ...IDV_VERIFICATION_CONFIG.loadingStatuses,
];

export function isExternalVerificationLoadingStatus(
  status: CheckoutStatus,
): boolean {
  return EXTERNAL_VERIFICATION_LOADING_STATUSES.includes(status);
}
